import { render } from "./iqcmodal.vue?vue&type=template&id=15d28ad0&scoped=true"
import script from "./iqcmodal.vue?vue&type=script&lang=js"
export * from "./iqcmodal.vue?vue&type=script&lang=js"

import "./iqcmodal.vue?vue&type=style&index=0&id=15d28ad0&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d28ad0"]])

export default __exports__